import { get2 } from "@/shared/axios";
import { imageLibraryKeys } from "@/shared/imageLibrary/queryKeys";
import {
  ImageLibraryItem,
  ImageLibraryParams,
} from "@/shared/imageLibrary/types";
import { useQuery } from "@tanstack/react-query";

const getImageLibrary = async (
  params: ImageLibraryParams
): Promise<ImageLibraryItem[]> => {
  const data = await get2("/internal/secure/pos/v1/image-library", { params });
  return Array.isArray(data) ? data : [];
};

/** Library items, optionally narrowed down by image type and kitchen type. */
const useImageLibraryQuery = (params: ImageLibraryParams = {}, enabled = true) =>
  useQuery({
    queryKey: imageLibraryKeys.items(params),
    queryFn: () => getImageLibrary(params),
    refetchOnWindowFocus: false,
    enabled,
  });

export default useImageLibraryQuery;
